import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import UserProfile from './UserProfile'
import { ENotificationType } from '../notification/ENotificationType'
import Notification from '../notification/Notification'
import envVariable from "../../util/envVariable"
import { useFolderId } from '../../../infrastructure/hooks'
import LocalStorageGateway from '../../../gateway/Form/LocalStorageGateway'

// Svg
import Back from '../svg/Back'
import Logout from '../svg/Logout'

const HeaderComponent = (): JSX.Element => {
  const { t } = useTranslation()
  const history = useHistory()
  const { folderId } = useFolderId()

  const logo = `${envVariable('REACT_APP_API_HOST')}/theme/images/logo.png`;
  const previousPage = localStorage.getItem("previousPage") || "/tableau-de-bord";

  const handleBackClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (folderId) {
      LocalStorageGateway.clearFolderData(folderId);
    }
    history.push(previousPage);
  };

  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => setErrorMessage(null), 3000)
    }
  }, [errorMessage])

  return (
    <div className="main-header u-mxl">
      <div className="flex-container middle-xs no-compensation">
        <h1 className="u-mb0 u-mrl">
          <a href="#">
            <img src={logo} alt="Société d'investissement" style={{ maxWidth: '150px' }} />
          </a>
        </h1>
        <Link to="#" className="back" onClick={handleBackClick}>
          <Back color="var(--ink-1)" />
          <span className="u-txt-size-l u-txt-color-ink-1 u-mxs">{t('button.back-home')}</span>
        </Link>
      </div>
      <div className="flex-container middle-xs left-xs u-txt-size-l">
        <div className={`u-mb0`}>
          {errorMessage && <Notification label={errorMessage} type={ENotificationType.error} canClose={false} />}
        </div>
      </div>
      <div className="flex-container middle-xs end-xs">
        <UserProfile hasIcon={false} />
        <Link to="/logout" className="button button-secondary button--medium button--logout button--width-fit u-pxs"><span className="text-logout">{t('button.logout')}</span> <Logout /></Link>
      </div>
    </div>
  );
}

export default HeaderComponent
